// utils/toast.js
let toastInstance = null;

/**
 * 显示轻提示
 * @param {string} message - 提示信息
 * @param {number} [duration=2000] - 显示时长（毫秒）
 * @param {string} [type='info'] - 提示类型：info/success/warning/error
 * @returns {void}
 */
export function showToast(message, duration = 3000, type = 'info') {
  // 如果已有toast实例，先移除它
  if (toastInstance) {
    document.body.removeChild(toastInstance);
  }

  // 创建toast元素
  const toast = document.createElement('div');

  // 设置基本样式
  toast.className = `vue-toast vue-toast-${type}`;
  toast.textContent = message;

  // 设置样式
  const isMobile = /mobile|android|iphone|ipad|phone/i.test(navigator.userAgent.toLowerCase())
  toast.style.cssText = `
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    background-color: rgba(0, 0, 0, 0.7);
    color: white;
    padding: ${isMobile ? '10rem 16rem' : '10px 16px'};
    border-radius: ${isMobile ? '4rem' : '4px'};
    font-size: ${isMobile ? '26rem' : '20px'};
    z-index: 9999;
    max-width: 80%;
    text-align: center;
    opacity: 0;
    transition: opacity 0.3s ease-in-out;
    box-shadow: 0 ${
      isMobile ? '2rem 10rem' : '2px 10px'
    } rgba(0, 0, 0, 0.1);
  `;

  // 根据类型设置不同的背景色
  const typeColors = {
    success: 'rgba(76, 175, 80, 0.9)',
    warning: 'rgba(255, 152, 0, 0.9)',
    error: 'rgba(244, 67, 54, 0.9)',
    info: 'rgba(0, 0, 0, 0.7)',
  };

  if (typeColors[type]) {
    toast.style.backgroundColor = typeColors[type];
  }

  // 添加到DOM
  document.body.appendChild(toast);

  // 保存实例引用
  toastInstance = toast;

  // 触发显示动画
  setTimeout(() => {
    toast.style.opacity = '1';
  }, 10);

  // 定时隐藏
  setTimeout(() => {
    toast.style.opacity = '0';

    // 动画结束后移除元素
    setTimeout(() => {
      if (toastInstance && document.body.contains(toastInstance)) {
        document.body.removeChild(toastInstance);
      }
      toastInstance = null;
    }, 300);
  }, duration);
}

// 注册为Vue插件
export default {
  install(Vue) {
    Vue.prototype.$toast = showToast;
  },
};
